import { render, staticRenderFns } from "./DeCenterDetail.vue?vue&type=template&id=6d0859ac&scoped=true"
import script from "./DeCenterDetail.vue?vue&type=script&lang=js"
export * from "./DeCenterDetail.vue?vue&type=script&lang=js"
import style0 from "./DeCenterDetail.vue?vue&type=style&index=0&id=6d0859ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0859ac",
  null
  
)

export default component.exports